module.exports = __webpack_public_path__ + "static/media/mo.3415c378.png";